import { atom, selector } from 'recoil';
import { useParams } from 'react-router-dom';
import { decrypt } from '@/utils';
import { verificarToken } from './storage';
import { SuccesHttpResponse } from '@/typings/generics';
import EstanciaRepository from '@/services/apirest/EstanciaRepository';
import { DatailsEstancia } from '@/typings/details-estancia';
import { BasicEstancia } from '@/typings/estancia';

interface Estancias {
  data: BasicEstancia[];
  pendientes: BasicEstancia[];
  proceso: BasicEstancia[];
  historico: BasicEstancia[];
  error: any;
}

export interface Estancia {
  id: number;
  data: DatailsEstancia;
  error: any;
}

async function fetchEstancias() {
  const response: SuccesHttpResponse =
    await EstanciaRepository.getObtenerLista();
  if (response.success) {
    const pendientes = response.data.filter(
      (estancia: BasicEstancia, index: number) => {
        if (
          estancia.id_estatus == '1' ||
          estancia.id_estatus == '2' ||
          estancia.id_estatus == '10' ||
          estancia.id_estatus == '12' ||
          estancia.id_estatus == '13'
        ) {
          estancia.key = index;
          return estancia;
        }
      }
    );
    const proceso = response.data.filter(
      (estancia: BasicEstancia, index: number) => {
        if (estancia.id_estatus == '3' || estancia.id_estatus == '4') {
          estancia.key = index;
          return estancia;
        }
      }
    );
    const historico = response.data.filter(
      (estancia: BasicEstancia, index: number) => {
        if (
          estancia.id_estatus == '5' ||
          estancia.id_estatus == '6' ||
          estancia.id_estatus == '7' ||
          estancia.id_estatus == '8' ||
          estancia.id_estatus == '9' ||
          estancia.id_estatus == '11'
        ) {
          estancia.key = index;
          return estancia;
        }
      }
    );
    const estancias: Estancias = {
      data: response.data,
      pendientes: pendientes,
      proceso: proceso,
      historico: historico,
      error: false,
    };
    return estancias;
  } else {
    return {
      error: response.data,
    } as Estancias;
  }
}

export async function fetchEstancia(id) {
  const response: SuccesHttpResponse =
    await EstanciaRepository.getObtenerEstancia(id);
  if (response.success) {
    const estancia: Estancia = {
      id: id,
      data: response.data,
      error: false,
    };
    return estancia;
  } else {
    return {
      error: response.data,
    } as Estancia;
  }
}

const estanciasEffect =
  () =>
  ({ setSelf }) => {
    const token = localStorage.getItem('tokenEcosurEstudiantesExternos');
    if (token && verificarToken(token)) {
      setSelf(fetchEstancias());
    }
  };

const estanciaEffect =
  () =>
  ({ setSelf, onSet, trigger }) => {
    const { id } = useParams();
    const token = localStorage.getItem('tokenEcosurEstudiantesExternos');
    if (trigger === 'get' && token && verificarToken(token) && id) {
      setSelf(fetchEstancia(decrypt(id)));
    }
    onSet(newValue => {
      if (token && verificarToken(token) && id) {
        setSelf(newValue);
      }
    });
  };

const estanciasState = atom({
  key: 'estanciasState',
  default: {} as Estancias,
  effects: [estanciasEffect()],
});

export const estanciaState = atom({
  key: 'estanciaState',
  default: {} as Estancia,
  effects: [estanciaEffect()],
});

export const estanciasInfo = selector({
  key: 'estanciasInfo',
  get: ({ get }) => ({
    estancias: get(estanciasState),
    data: get(estanciasState).data,
    pendientes: get(estanciasState).pendientes,
    proceso: get(estanciasState).proceso,
    historico: get(estanciasState).historico,
    error: get(estanciasState).error,
  }),
});

export const estanciaInfo = selector({
  key: 'estanciaInfo',
  get: ({ get }) => ({
    estancia: get(estanciaState),
    id: get(estanciaState).id,
    data: get(estanciaState).data,
    nombre_estudiante: get(estanciaState).data.nombre_estudiante,
    estatus_id: get(estanciaState).data.estatus_id,
    estatus_leyenda: get(estanciaState).data.estatus_leyenda,
    asesor_nombre: get(estanciaState).data.asesor_nombre,
    asesor_departamento: get(estanciaState).data.asesor_departamento,
    proyecto: get(estanciaState).data.proyecto,
    institucion: get(estanciaState).data.institucion,
    nombre_institucion: get(estanciaState).data.nombre_institucion,
    modalidad: get(estanciaState).data.modalidad,
    tipo_estancia: get(estanciaState).data.tipo_estancia,
    tipo_seguro_salud: get(estanciaState).data.tipo_seguro_salud,
    numero_seguro_salud: get(estanciaState).data.numero_seguro_salud,
    nivel_estudios: get(estanciaState).data.nivel_estudios,
    carrera: get(estanciaState).data.carrera,
    fecha_inicio: get(estanciaState).data.fecha_inicio,
    fecha_fin: get(estanciaState).data.fecha_fin,
    numero_horas: get(estanciaState).data.numero_horas,
    matricula: get(estanciaState).data.matricula,
    numero_credencial: get(estanciaState).data.numero_credencial,
    correo_inst: get(estanciaState).data.correo_inst,
    telefono: get(estanciaState).data.telefono,
    telefono_familiar: get(estanciaState).data.telefono_familiar,
    nombre_familiar: get(estanciaState).data.nombre_familiar,
    alergias: get(estanciaState).data.alergias,
    razon_rechazo_cancelacion:
      get(estanciaState).data.razon_rechazo_cancelacion,
    archivos: get(estanciaState).data.archivos,
    institucion_contacto_nombre:
      get(estanciaState).data.institucion_contacto_nombre,
    institucion_contacto_puesto:
      get(estanciaState).data.institucion_contacto_puesto,
    error: get(estanciaState).error,
  }),
});
